// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Lc-d","label":"LabeledBox_label__4D4DY"};